// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title_1nslZ","list":"index_list_2n4JT","content":"index_content_1rPU6","plans":"index_plans_2Oe3B"};